// ===================================================================
// KAIXO - UpgradeModal: se abre cuando el backend devuelve
// plan_limit_exceeded o plan_quota_exceeded.
// ===================================================================
// Uso:
//   1. Escucha global en App.js via axios interceptor:
//        if (error.response?.data?.error === 'plan_limit_exceeded') {
//            window.dispatchEvent(new CustomEvent('kaixo-upgrade-required',
//               { detail: error.response.data }));
//        }
//   2. Este modal escucha ese evento y se abre automáticamente.
// ===================================================================

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PlansModal from './PlansModal';

function UpgradeModal() {
    const [detail, setDetail] = useState(null);
    const [showPlans, setShowPlans] = useState(false);

    useEffect(() => {
        const handler = (e) => setDetail(e.detail);
        window.addEventListener('kaixo-upgrade-required', handler);
        return () => window.removeEventListener('kaixo-upgrade-required', handler);
    }, []);

    if (!detail) return null;

    if (showPlans) {
        return (
            <PlansModal
                onClose={() => { setShowPlans(false); setDetail(null); }}
                highlightPlan={detail.requiredPlan}
            />
        );
    }

    return ReactDOM.createPortal(
        <div
            onClick={() => setDetail(null)}
            style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                zIndex: 10001, padding: 16
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    background: '#fff', borderRadius: 16, maxWidth: 420,
                    width: '100%', padding: 28, textAlign: 'center',
                    fontFamily: 'system-ui, sans-serif'
                }}
            >
                <div style={{ fontSize: 44, marginBottom: 12 }}>🔒</div>
                <h3 style={{ color: '#F5A000', margin: '0 0 8px' }}>
                    Función limitada
                </h3>
                <p style={{ color: '#333', fontSize: 15, margin: '0 0 20px' }}>
                    {detail.message || 'Necesitas un plan superior para esta acción.'}
                </p>

                {detail.requiredPlan && (
                    <p style={{ color: '#667781', fontSize: 13, margin: '0 0 20px' }}>
                        Plan actual: <strong>{detail.currentPlan}</strong><br />
                        Plan recomendado: <strong>{detail.requiredPlan}</strong>
                    </p>
                )}

                <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                    <button
                        onClick={() => setDetail(null)}
                        style={{
                            background: '#EAEAEA', color: '#333',
                            border: 'none', padding: '10px 18px',
                            borderRadius: 10, fontSize: 14, cursor: 'pointer'
                        }}
                    >
                        Más tarde
                    </button>
                    <button
                        onClick={() => setShowPlans(true)}
                        style={{
                            background: '#F5A000', color: '#fff',
                            border: 'none', padding: '10px 22px',
                            borderRadius: 10, fontSize: 14, fontWeight: 600,
                            cursor: 'pointer'
                        }}
                    >
                        Ver planes
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default UpgradeModal;
